module.exports = __webpack_public_path__ + "img/work2020mvf.ab4e5039.png";